// extracted by mini-css-extract-plugin
export default {"defaultMargin":"-4px","link":"MHdsph","SloopyButton":"UVbKYz","sloopyButton":"UVbKYz","label":"RbX9GB","brd":"cGW91K","top":"Hce8Ti","bot":"YUYpbz"};